import React, { useState } from 'react';
import { Button, Form, Icon, Input, Table, Tag, Typography } from 'antd';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { tailFormItemLayout } from '../../utils/formLayouts';
import { ContentCustom } from '../../components';
import { invoiceTypeColors } from '../../utils';

const { Title } = Typography;
const { Column } = Table;

const PaymentList = ({
  allInvoices,
  isLoading,
  isTableLoading,
  handleChange,
  handleReset,
  handleSearch,
  pagination,
  invoices,
  selectInvoices,
  selectAllInvoices,
  enums,
  filteredInfo,
  id
}) => {
  const { t } = useTranslation();
  const history = useHistory();
  const [searchInput, setSearchInput] = useState(null);
  return (
    <ContentCustom marginTop={8}>
      <Title level={3}>{t(`payments.create.paymentList`)}</Title>
      <Table
        dataSource={allInvoices}
        loading={isTableLoading}
        onChange={handleChange}
        pagination={pagination}
        rowSelection={{
          onChange: (selectedRowKeys, selectedRows) =>
            selectInvoices(selectedRowKeys, selectedRows),
          selectedRowKeys: invoices,
          onSelectAll: (selected, selectedRows, changeRows) =>
            selectAllInvoices(selected, selectedRows, changeRows)
        }}
      >
        <Column
          title={t(`invoices.list.column.number`)}
          dataIndex="number"
          filterDropdown={({
            setSelectedKeys,
            selectedKeys,
            confirm,
            clearFilters
          }) => (
            <div style={{ padding: 8 }}>
              <Input
                ref={(node) => {
                  setSearchInput(node);
                }}
                placeholder="Number"
                value={selectedKeys[0]}
                onChange={(e) =>
                  setSelectedKeys(e.target.value ? [e.target.value] : [])
                }
                onPressEnter={() =>
                  handleSearch('number', selectedKeys, confirm)
                }
                style={{ width: 188, marginBottom: 8, display: 'block' }}
              />
              <Button
                type="primary"
                onClick={() => handleSearch('number', selectedKeys, confirm)}
                icon="search"
                size="small"
                style={{ width: 110, marginRight: 8 }}
              >
                Rechercher
              </Button>
              <Button
                onClick={() => handleReset(clearFilters)}
                size="small"
                style={{ width: 90 }}
              >
                Reset
              </Button>
            </div>
          )}
          filterIcon={(filtered) => (
            <Icon
              type="search"
              style={{ color: filtered ? '#1890ff' : undefined }}
            />
          )}
          onFilterDropdownVisibleChange={(filterVisible) => {
            if (filterVisible) {
              setTimeout(() => searchInput.select());
            }
          }}
        />
        <Column
          title={t(`invoices.list.column.type`)}
          dataIndex="type"
          render={(type) => <Tag color={invoiceTypeColors[type]}>{type}</Tag>}
          filters={
            enums &&
            enums.type &&
            enums.type.map((enumValue) => ({
              text: enumValue,
              value: enumValue
            }))
          }
          filteredValue={filteredInfo.type || null}
        />
        <Column
          title={t(`invoices.list.column.total`)}
          dataIndex="total"
          filterDropdown={({
            setSelectedKeys,
            selectedKeys,
            confirm,
            clearFilters
          }) => (
            <div style={{ padding: 8 }}>
              <Input
                ref={(node) => {
                  setSearchInput(node);
                }}
                placeholder="Total"
                value={selectedKeys[0]}
                onChange={(e) =>
                  setSelectedKeys(e.target.value ? [e.target.value] : [])
                }
                onPressEnter={() =>
                  handleSearch('total', selectedKeys, confirm)
                }
                style={{ width: 188, marginBottom: 8, display: 'block' }}
              />
              <Button
                type="primary"
                onClick={() => handleSearch('total', selectedKeys, confirm)}
                icon="search"
                size="small"
                style={{ width: 110, marginRight: 8 }}
              >
                Rechercher
              </Button>
              <Button
                onClick={() => handleReset(clearFilters)}
                size="small"
                style={{ width: 90 }}
              >
                Reset
              </Button>
            </div>
          )}
          filterIcon={(filtered) => (
            <Icon
              type="search"
              style={{ color: filtered ? '#1890ff' : undefined }}
            />
          )}
          onFilterDropdownVisibleChange={(filterVisible) => {
            if (filterVisible) {
              setTimeout(() => searchInput.select());
            }
          }}
        />
      </Table>
      <Form.Item style={{ marginTop: 50 }} {...tailFormItemLayout}>
        <Button loading={isLoading} type="primary" htmlType="submit">
          {t(`payments.form.button.${id ? 'edit' : 'create'}`)}
        </Button>
        <Button
          style={{ marginLeft: 10 }}
          type="danger"
          onClick={() => {
            history.goBack();
          }}
        >
          {t('payments.form.button.cancel')}
        </Button>
      </Form.Item>
    </ContentCustom>
  );
};

PaymentList.propTypes = {
  allInvoices: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  isLoading: PropTypes.bool.isRequired,
  isTableLoading: PropTypes.bool.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleReset: PropTypes.func.isRequired,
  handleSearch: PropTypes.func.isRequired,
  pagination: PropTypes.shape({}).isRequired,
  invoices: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  selectInvoices: PropTypes.func.isRequired,
  selectAllInvoices: PropTypes.func.isRequired,
  enums: PropTypes.shape({
    type: PropTypes.arrayOf(PropTypes.string)
  }).isRequired,
  filteredInfo: PropTypes.shape({
    type: PropTypes.string
  }).isRequired,
  id: PropTypes.string.isRequired
};

export default PaymentList;
